import { useRef, useState, useEffect } from "react";
import HighlightCard from "../../components/HighlightCard";
import Slider from "../../components/Slider";

const Resources = ({ resources, resourcesInfo }) => {
  const card = useRef(null);
  const [stepSize, setStepSize] = useState();
  useEffect(() => {
    const { offsetWidth } = card.current;
    setStepSize(offsetWidth);
  }, []);
  return (
    <section className="usecases_resources_section">
      <div className="usecases_resources_section-container">
        <h2>{resourcesInfo.title}</h2>
        <p className="usecases_resources_section-subtitle">{resourcesInfo.description}</p>
        <Slider stepSize={stepSize}>
          {resources.map(resource => (
            <HighlightCard key={resource.url} ref={card} {...resource} />
          ))}
        </Slider>
      </div>
    </section>
  );
};

Resources.defaultProps = {
  resources: [],
  resourcesInfo: {},
};

export default Resources;
